import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Register from './pages/Register';
import Verify from './pages/Verify';
import Dashboard from './pages/Dashboard';

// KOMPONENT STRONY GŁÓWNEJ
const Home = () => {
  return (
    <div>
      <section className="relative pt-32 pb-20 px-6 overflow-hidden">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-cyan-500/10 blur-[120px] pointer-events-none" />
        <div className="max-w-7xl mx-auto text-center relative z-10">
          <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 px-4 py-2 rounded-full mb-8">
            <span className="w-2 h-2 bg-cyan-500 rounded-full animate-pulse" />
            <span className="text-xs font-bold uppercase tracking-widest text-cyan-400">Najszybszy Hosting NVMe 2026</span>
          </div>
          <h1 className="text-5xl md:text-7xl font-black mb-6 leading-tight text-white">
            Wydajność, która<br />
            <span className="bg-gradient-to-r from-cyan-400 to-blue-600 bg-clip-text text-transparent">napędza Twój biznes.</span>
          </h1>
          <p className="max-w-2xl mx-auto text-gray-400 text-lg mb-10">
            Zapomnij o wolnych stronach. Przenieś się na neohost.pl i poczuj różnicę dzięki dyskom NVMe i procesorom najnowszej generacji.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/register" className="w-full sm:w-auto bg-cyan-500 hover:bg-cyan-400 px-8 py-4 rounded-2xl font-black text-lg transition shadow-xl shadow-cyan-500/20 text-white text-center">
              Zacznij teraz
            </Link>
            <a href="#pricing" className="w-full sm:w-auto bg-white/5 hover:bg-white/10 border border-white/10 px-8 py-4 rounded-2xl font-bold text-lg transition text-white text-center">
              Zobacz cennik
            </a>
          </div>
        </div>
      </section>

      {/* FEATURES SECTION */}
      <section id="features" className="py-24 px-6 bg-black/20 text-center">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold mb-16 text-white">Dlaczego my?</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="p-8 bg-white/5 border border-white/10 rounded-3xl">Dyski NVMe Gen4</div>
            <div className="p-8 bg-white/5 border border-white/10 rounded-3xl">Darmowy SSL</div>
            <div className="p-8 bg-white/5 border border-white/10 rounded-3xl">Support 24/7</div>
          </div>
        </div>
      </section>
    </div>
  );
};

// Strażnik dostępu do Dashboardu
const PrivateRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  return isLoggedIn ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <div className="bg-[#0f172a] min-h-screen text-white font-sans selection:bg-cyan-500/30">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        </Routes>

        <footer className="py-20 border-t border-white/5 bg-black/20">
          <div className="max-w-7xl mx-auto px-6 text-center text-gray-500 text-sm">
            &copy; 2026 neohost.pl - Wszystkie prawa zastrzeżone.
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;